export default __webpack_public_path__ + "static/media/others.f14ba345.svg";